export const DEFAULT_LANGUAGE = "es";

export const REGEX = {
  MAIL: /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/,
  NIF: /([a-z]|[A-Z]|[0-9])[0-9]{7}([a-z]|[A-Z]|[0-9])/,
  PHONE: /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]{5,}$/,
  NUMBER: /^[0-9]*$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*.?&]{8,}$/,
};

export const MENU_OPTIONS = [
  {
    title: "Wipe Mode",
    icon: "icon-ic_menu_wipe-mode",
  },
];

export const ENV = {
  dev: true,
};

export const ZONE_HOUR = {
  pm: "pm",
  am: "am",
};

export function getEnvironment() {
  return {
    API_URL: ENV.dev ? "dev.cowing.com" : "dev.conwing.com",
    GMAP_KEY: "",
    GMAP_IOS_KEY: "",
    APP_VERSION: "0.0.1",
  };
}

export const PHONE_SETTINGS = {
  RING_TONE: {
    title: "phone.settings.ringtone",
  },
  RING_VOLUME: {
    title: "phone.settings.volume",
  },
  CONFIG_LAND: {
    title: "phone.settings.land",
  },
};

export const WEEK_DAYS = {
  MONDAY: "Monday",
  TUESDAY: "Tuesday",
  WEDNESDAY: "Wednesday",
  THURSDAY: "Thursday",
  FRIDAY: "Friday",
  SATURDAY: "Saturday",
  SUNDAY: "Sunday",
};

export const COWING_KEY = "Wm5KdmJuUkRiM2RwYm1kTFpYaz1wcml2YXRl";
export const COWING_PRIVATE = "private";
export const COWING_SEPARATOR = "_C_W_";
